<app-breadcrumbs></app-breadcrumbs>
<app-sale-list></app-sale-list>
